import { graphql } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';

import { IContentfulImage } from '../../../interfaces/contentful-image.interface';
import { TextArrayProps } from '../../page-components/editorial-page-full-width/editorial-page-full-width';
import EditorialPageFullWidthTextWrapper, {
  FullWidthTextBlockProps,
} from '../../page-components/editorial-page-full-width/editorial-page-full-width-text-wrapper';
import EditorialPageFullWidthWrapper from '../../page-components/editorial-page-full-width/editorial-page-full-width-wrapper';

export interface FullWidthBannerProps extends FullWidthTextBlockProps {
  banner?: IContentfulImage;
  textItem?: TextArrayProps;
  topBlock?: boolean;
}

const EditorialFullWidthBannerBlock = ({
  banner,
  body,
  textItem,
  topBlock,
}: FullWidthBannerProps) => {
  const image: any = banner?.gatsbyImageData ? banner?.gatsbyImageData : null;
  return (
    <EditorialPageFullWidthWrapper
      banner={true}
      topBlock={topBlock ? topBlock : null}
      isImage={banner?.gatsbyImageData ? true : false}
    >
      <GatsbyImage
        alt={banner?.description ? banner?.description : ''}
        image={image}
        className="aspect-1.5/1 w-full transform-gpu rounded-card-mobile xl:max-h-[80vh] "
      />
      <EditorialPageFullWidthTextWrapper
        body={body ? body : undefined}
        textItem={textItem}
      />
    </EditorialPageFullWidthWrapper>
  );
};

export default EditorialFullWidthBannerBlock;

export const query = graphql`
  fragment BlockEditorialFullWidthBanner on ContentfulBlockEditorialFullWidthBanner {
    blocktype: __typename
    title
    banner {
      description
      gatsbyImageData(width: 1500, height: 1000, formats: AVIF)
    }
    preamble
    body {
      raw
      references {
        ...Entry
        ...Asset
      }
    }
  }
`;
